import { Text } from '@medly-components/core';
import { Container, Content, VideoWrapper } from './MapIntro.styled';
import { MapIntroDescription, MapIntroTitle } from 'constants/text/mapOnboarding';
import { PageTitle } from 'components/common/Styled';
import { MAP_TUTORIAL_VIDEO_URL } from 'constants/map';
import { VideoPlayer } from 'components/common';

export const MapIntro = () => {
    return (
        <Container>
            <Content>
                <PageTitle textVariant="h1">{MapIntroTitle}</PageTitle>
                <Text textVariant="body1">{MapIntroDescription}</Text>
            </Content>
            <VideoWrapper>
                <VideoPlayer url={MAP_TUTORIAL_VIDEO_URL} />
            </VideoWrapper>
        </Container>
    );
};
